import { render, staticRenderFns } from "./AvaliacaoPerguntaEditar.vue?vue&type=template&id=5bb5665f&"
import script from "./AvaliacaoPerguntaEditar.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoPerguntaEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports